import { Button, FAIcon, H2 } from '@/components'
import { PERMISSIONS } from '@/utils'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { ResultOf } from 'gql.tada'
import { BrowserView, MobileView } from 'react-device-detect'
import { useRef, useState } from 'react'
import { PermissionsOrMeRequired } from '@/containers/permission-containers'
import { AbsenceDetailsInner } from './absence-details'
import type { ABSENCE_DETAILS_QUERY } from '../queries'
import styled from 'styled-components'
import { Icon } from '@ur-solutions/react-components'

const ActionWrapper = styled.div`
  color: ${props => props.theme.colors.gray1};
  background-color: ${props => props.theme.colors.gray8};
  border-radius: ${props => props.theme.sizes.defaultBorderRadius};
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  & > div {
    width: 100%;
    padding: 0.5rem 1rem;
  }
  & > div:hover {
    background-color: ${props => props.theme.colors.gray7};
    cursor: pointer;
  }
`

export type AbsenceDetailsNode = ResultOf<
  typeof ABSENCE_DETAILS_QUERY
>['absence']

interface AbsenceDetailsInnerRef {
  edit(): void
}

export function AbsenceDetailsSalary({
  absenceId,
  onClose,
}: {
  absenceId: string
  onClose?: () => void
}) {
  const translations = useTranslate({
    absences: 'common.absences',
    editAbsence: 'absence.details.edit-absence',
  })

  const innerRef = useRef<AbsenceDetailsInnerRef>(null)

  const [absence, setAbsence] = useState<AbsenceDetailsNode>()

  function handleEdit() {
    innerRef.current?.edit()
  }

  return (
    <div>
      {onClose && (
        <div className="flex items-center justify-between mb-4">
          {/* Make text  in */}
          <div className="flex items-center gap-2">
            <ActionWrapper>
              <div onClick={() => onClose()}>
                <Icon icon="arrow-left" onClick={() => onClose()} />
              </div>
            </ActionWrapper>
            <H2 className="mb-0">{translations.absences}</H2>
          </div>
          <PermissionsOrMeRequired
            user={{ id: absence?.user.id ?? '' }}
            permissions={PERMISSIONS.timesheets.change.othersabsence}
          >
            <MobileView>
              <Button
                size="icon-md"
                aria-label={translations.editAbsence}
                onClick={handleEdit}
              >
                <FAIcon icon="edit" />
              </Button>
            </MobileView>

            <BrowserView>
              <Button size="lg" onClick={handleEdit}>
                <FAIcon icon="edit" />
                {translations.editAbsence}
              </Button>
            </BrowserView>
          </PermissionsOrMeRequired>
        </div>
      )}
      <AbsenceDetailsInner
        ref={innerRef}
        overrideAbsenceId={absenceId}
        onAbsenceLoad={value => absence?.id !== value.id && setAbsence(value)}
      />
    </div>
  )
}
